<template>
    <div v-if="open" :class="['popup']">
        <div @click="closePopup" class="bg_popup"></div>
        <div @click="closePopup" class="btn-close"></div>
        <div :class="['popup-body', addPopupClass]">

            <form-category
                v-if="typeinformation === 'category'"
                :crud="crud"
                :data="data"
            ></form-category>

            <form-user
                v-if="typeinformation === 'user'"
                :crud="crud"
                :data="data"
            ></form-user>

            <form-person
                v-if="typeinformation === 'formperson'"
                :prop_titleform="title_form"
                :category_id="category_id"
                :person="person"
                :crud="crud"
            ></form-person>

            <merge-person
                v-if="typeinformation === 'mergeperson'"
                :prop_titleform="title_form"
                :category_id="category_id"
                :person="person"
                :crud="crud"
            ></merge-person>

            <move-person
                v-if="typeinformation === 'moveperson'"
                :prop_titleform="title_form"
                :category_id="category_id"
                :personsIds="personsIds"
                :categoryListType="categoryListType"
                :crud="crud"
            ></move-person>

            <form-uploadvideo 
                v-if="typeinformation === 'formuploadvideo'" 
                :prop_titleform="title_form"
                :prop_videos="videos"
                :crud="crud"
            ></form-uploadvideo>

            <form-add-camera 
                v-if="typeinformation === 'formaddcamera'" 
                :prop_titleform="title_form"
                :camera="camera"
                :crud="crud"
            ></form-add-camera>

            <camera-stream-view
                v-if="typeinformation === 'camerastream'"
                :camera="camera"
            ></camera-stream-view>

            <video-file-player-view
                v-if="typeinformation === 'videoplayer'"
                :video="video"
            ></video-file-player-view>

            <form-report v-if="typeinformation === 'formreport'"
                 :prop_titleform="title_form"
                 :data="report"
                 :crud="crud"
            ></form-report>
            
            <add-person-report v-if="typeinformation === 'addpersonreport'"
                 :prop_titleform="title_form"
                 :prop_add_person_report="add_person_report"                 
            ></add-person-report>

        </div>
    </div>
</template>

<script>
import {bus} from '../bus';
import FormCategory from "./Forms/FormCategory";
import FormPerson from "./Forms/FormPerson";
import FormUser from "./Forms/FormUser";
import FormUploadvideo from "./Forms/FormUploadvideo";
import FormAddCamera from "./Forms/FormAddCamera";
import CameraStreamView from "./Forms/CameraStreamView.vue";
import VideoFilePlayerView from "./Forms/VideoFilePlayerView.vue";
import FormReport from "./Forms/FormReport";
import MergePerson from "./Forms/MergePerson";
import MovePerson from "./Forms/MovePerson.vue";
import AddPersonReport from "./Notices/AddPersonReport.vue";

export default {
    data(){
        return{
            open: false,
            data: {},
            typeinformation: '',
            title_form: '',
            crud: 'create',
            category_id: 0,
            person: {},
            camera: {},
            video: {},
            report: {},
            videos: [],
            personsIds: [],
            categoryListType: 'merge',
            addPopupClass: '',
            add_person_report: {},
            prop_videos: []
        }
    },
    methods:{
        closePopup(){
            this.open = false;
            this.typeinformation = '';
        }
    },
    mounted(){
        bus.$on('openpopup', (data) => {

            this.open = data.open;

            if (data.open === false) {
                this.typeinformation = '';
            }

            if(data.add_person_report){
                
                
                
                this.add_person_report = data.add_person_report;

                console.log('this.add_person_report 2 (in popup) : ', this.add_person_report);
                console.log(this.add_person_report);
            }

            console.log('data.prop_videos: ', data.prop_videos);

            if(data.prop_videos){
                this.prop_videos = data.prop_videos;
            }
                        
            if(data.addPopupClass){
                this.addPopupClass = data.addPopupClass;
            }
            
            if(data.categoryListType){
                this.categoryListType = data.categoryListType;
            }

            if(data.personsIds){
                this.personsIds = data.personsIds;
            }            
            
            if(data.type){
                this.typeinformation = data.type;
            }

            if(data.crud){
                this.crud = data.crud;
            }

            if(data.title_form){
                this.title_form = data.title_form;
            }

            if(data.category_id){
                this.category_id = data.category_id;
            }

            if(data.data){
                this.data = data.data;
            }

            if(data.person){
                this.person = data.person;
            }

            if(data.camera){
                this.camera = data.camera;
            }

            if(data.video){
                this.video = data.video;
            }

            if(data.report){
                this.report = data.report;
                console.log(this.report);
            }

            if(data.videos){
                this.videos = data.videos;
                console.log(this.videos);
            }

        });
    },
    components:{
        FormCategory,
        FormUser,
        FormPerson,
        FormUploadvideo,
        FormAddCamera,
        CameraStreamView,
        VideoFilePlayerView,
        FormReport,
        MergePerson,
        MovePerson,
        AddPersonReport
    }

}
</script>

<style lang="scss" scoped>
    .editreport{        
        height: 30vh;        
    }
</style>

<style lang="scss">
    /* Unscoped: popup-body class is toggled from parent data */
    .popup-body.camera-stream-popup {
        width: auto;
        max-width: 960px;
        padding: 0;
    }
</style>
